import { prefix } from '../config';

// eslint-disable-next-line import/prefer-default-export
export const COMPONENT_NAME = `${prefix}-anchor` as const;
